<template lang="pug">
#bill-info
  v-banner.title-banner(min-height="88")
    .text-h4.font-weight-bold {{ $t('Menu.__Purchase') }} : {{ editType == 1 ? $t('Bills.__AddBill') : $t('Bills.__EditBill') }}
    template(v-slot:actions)
      //- v-btn.ml-6(v-if="editType!=1" rounded outlined color="primary" @click="deleteItem")  {{$t('Bills.__DeleteBill')}}
      v-btn.ml-6(rounded, dark, color="#b4b9be", @click="$router.go(-1)") {{ $t('ActionOption.__Cancel') }}
      v-btn.ml-6(rounded, color="primary", @click="saveEdit", min-width="112") {{ $t('ActionOption.__Save') }}
  v-container
    Alert
    ConfirmDialog(
      v-model="deleteTransactionDialog",
      :title="$t('Transactions.__DeleteTransaction')",
      :message="$t('Transactions.__ConfirmDeleteTransaction')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteTransaction"
    )

    ConfirmDialog(
      v-model="deleteDialog",
      :title="$t('Bills.__DeleteBill')",
      :message="$t('Bills.__ConfirmDeleteBill')",
      :cancel-text="$t('ActionOption.__Cancel')",
      :confirm-text="$t('ActionOption.__Delete')",
      :confirm-action="deleteBill"
    )
    #transactionRecordsSection(v-if="editType != 1")
      v-card
        v-card-title {{ $t('Bills.__PaymentRecords') }}
        v-card-subtitle {{ $t('Bills.__AmountDue') }} {{ currency.symbol }} {{ bill.unpaid }}
        v-card-text
          v-data-table(:headers="recordHeaders", :items="transactionRecords", hide-default-footer, disable-pagination)
            template(v-slot:item.amount="{ item }")
              |
              | {{ currency.symbol }}{{ item.amount }}
            template(v-slot:item.actions="{ item }")
              v-btn.ma-0(
                text,
                icon,
                small,
                color="primary",
                @click="deleteTransactionDialog = true; selectTransaction = item",
                title="delete"
              )
                v-icon(small) delete
      v-divider.my-6

    #editSection(:class="mode == 2 ? 'd-none' : ''")
      v-form(v-model="formValid", ref="billform")
        v-row
          v-col(cols="12", md="")
            v-text-field(
              v-model="bill.name",
              solo,
              dense,
              outlined,
              required,
              :rules="[rules.required]",
              :placeholder="$t('Bills.__Title')"
            )
          v-col(cols="12", md="")
            v-text-field(
              v-model="bill.number",
              solo,
              dense,
              outlined,
              required,
              :rules="[rules.required]",
              prefix="#",
              :placeholder="$t('Bills.__No')"
            )
          v-col(cols="12", md="")
            //- v-text-field(v-model="bill.subHeader" solo dense outlined  placeholder="副標題")
          v-col.d-none.d-md-block(cols="12", md="")
          v-col.d-none.d-md-block(cols="12", md="")
        v-divider.mb-6
        v-row
          v-col(cols="12", md="")
            .field-label 
              span {{ $t('Bills.__Vendor') }}
              span.required *
            VendorSelector(v-model="bill.vendor", :insert-tag="true", :rules="[rules.required]")
          //- v-col(cols="12" md="")
          //- .field-label 
          //-     span 貨幣單位
          //-     span.required *
          //- CurrencySelector(v-model="bill.currencyCode" readonly)

          v-col(cols="12", md="")
            .field-label 
              span {{ $t('Bills.__BillDate') }}
            v-menu(
              v-model="startDateMenu",
              offset-y,
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="bill.issuedAt",
                  clearable,
                  hide-details,
                  solo,
                  dense,
                  outlined,
                  readonly,
                  append-icon="event",
                  v-on="on",
                  :rules="[rules.required]",
                  :placeholder="$t('Placeholder.__Date')",
                  :disabled="editType != 1"
                )
              v-date-picker(
                v-model="bill.issuedAt",
                @input="startDateMenu = false",
                :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
              )
          v-col(cols="12", md="")
            .field-label 
              span {{ $t('Bills.__BillExpiredDate') }}
            v-menu(
              v-model="endDateMenu",
              offset-y,
              :close-on-content-click="false",
              :nudge-right="40",
              transition="scale-transition",
              min-width="290px"
            )
              template(v-slot:activator="{ on }")
                v-text-field(
                  v-model="bill.expiredAt",
                  clearable,
                  hide-details,
                  solo,
                  dense,
                  outlined,
                  readonly,
                  append-icon="event",
                  v-on="on",
                  :rules="[rules.required]",
                  :placeholder="$t('Placeholder.__Date')"
                )
              v-date-picker(
                v-model="bill.expiredAt",
                @input="endDateMenu = false",
                :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
              )
          v-col(cols="12", md="")
            .field-label 
              span P.O. / S.O.
            v-text-field(v-model="bill.poso", solo, dense, outlined)
          v-col
        v-row
          v-col(cols="12")
            v-card.mb-6
              v-card-text
                v-simple-table.insert-table(v-slot:default)
                  thead(style="background-color: #fae3d8")
                    tr
                      th(v-for="header in headers", :width="header.width", :style="header.style", :class="header.class") {{ header.text }}
                  tbody#dragTable
                    tr(v-for="(item, i) in bill.items")
                      //- td.drag-handle
                      //-   v-icon(small) drag_handle
                      td 
                        ProductSelector(
                          v-if="item.name == '' || item.name == undefined",
                          v-model="item.product",
                          category="buy",
                          @input="productItemChanged(i)"
                        )
                        .product-name(v-else) {{ item.name }}

                      td
                        AccountSelector(
                          v-model="item.accountId",
                          :groupKeys="['Liabilities', 'Income', 'OperatingCosts', 'OperatingExpenses', 'OwnersEquity']",
                          hide-details,
                          :insert-tag="true"
                        ) 
                        //- v-textarea(v-model="item.category" solo dense hide-details outlined rows="1" :placeholder="$t('Bills.__AccountName')")

                        //- v-text-field(v-else v-model="item.name" solo dense outlined hide-details required readonly)
                      td
                        v-textarea(v-model="item.description", solo, dense, hide-details, outlined, rows="1")
                      td
                        v-text-field(
                          v-model.number="item.quantity",
                          solo,
                          dense,
                          outlined,
                          hide-details,
                          required,
                          min="0",
                          type="number",
                          :placeholder="$t('Bills.__Quantity')",
                          @input="updateAmount"
                        )
                      td
                        v-text-field(
                          v-model.number="item.price",
                          solo,
                          dense,
                          outlined,
                          hide-details,
                          required,
                          min="0",
                          type="number",
                          :placeholder="$t('Bills.__Amount')",
                          @input="updateAmount"
                        )
                      td
                        TaxesSelector(v-model="item.taxes", @input="updateAmount", hide-details)

                      td.text-right
                        span {{ currency.symbol }}
                        span {{ item.amount }}
                        .tax-area
                          .tax-amount(v-for="tax in item.taxes")
                            span.tax-name.mr-2 {{ tax.name }}
                            span {{ currency.symbol }}
                            span {{ tax.amount }}
                      td
                        v-btn.ma-0(text, icon, small, color="primary", @click="removeItem(i)", title="clear")
                          v-icon(small) clear
                    tr.no-hover
                      td(colspan="9")
                        v-btn(text, color="primary", @click="addItem()")
                          v-icon(left, small) add
                          | {{ $t('Bills.__AddItem') }}
                  tfoot 
                    tr.no-hover
                      td.pt-2(colspan="5", style="vertical-align: top")
                        //- v-btn(text color="primary" @click="addItem()")
                        //-     v-icon(left small) add
                        //-     | 新增帳單項目
                      td.text-right.pt-2.px-0(colspan="2", style="vertical-align: top")
                        v-simple-table(dense)
                          tr.subtotal.no-border
                            td.font-weight-bold.mr-10 {{ $t('Bills.__Subtotal') }}
                            td {{ currency.symbol }} {{ bill.subtotal }}
                          tr.taxtotal.no-border
                            td.font-weight-bold.mr-10 {{ $t('Bills.__Tax') }}
                            td {{ currency.symbol }} {{ bill.taxAmount }}
                          tr.total.no-border
                            td.font-weight-bold.mr-10 {{ $t('Bills.__Total') }} ({{ currency.code }})
                            td {{ currency.symbol }} {{ bill.total }}
                          tr.paid.no-border
                            td.font-weight-bold.mr-10 {{ $t('Bills.__PaymentAmount') }} ({{ currency.code }})
                            td {{ currency.symbol }} {{ bill.paid }}
                          tr.unpaid.no-border
                            td.font-weight-bold.mr-10 {{ $t('Bills.__AmountDue') }} ({{ currency.code }})
                            td {{ currency.symbol }} {{ bill.unpaid }}
                      td
            .field-label 
              span {{ $t('Bills.__Memo') }}
            v-textarea(v-model="bill.memo", solo, outlined, height="80")
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"
// import Sortable from "sortablejs"
import * as currencyHelper from "@/utils/currencies.js"
import * as unsaveNotify from "@/utils/unsaveNotify.js"

export default {
  mixins: [currencyHelper.mixin, unsaveNotify.mixin],
  data() {
    return {
      id: "new",
      biz: {},
      mode: 1,
      rules: textfieldUtils.rules,
      formValid: false,
      editType: 1,
      startDateMenu: false,
      endDateMenu: false,
      deleteTransactionDialog: false,
      selectTransaction: {},
      deleteDialog: false,
      deleteId: null,
      transactionRecords: [],
      recordHeaders: [
        {
          text: this.$t("Transactions.__Date"),
          align: "start",
          sortable: true,
          value: "date"
        },
        {
          text: this.$t("Transactions.__Amount"),
          align: "end",
          sortable: true,
          value: "amount"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      headers: [
        // {
        //   text: "",
        //   width: "20px",
        //   style: ""
        // },
        {
          text: this.$t("Bills.__Item"),
          width: "15%",
          style: "min-width:200px"
        },
        {
          text: this.$t("Bills.__ExpenseAccount"),
          width: "20%",
          style: "min-width:200px"
        },
        {
          text: this.$t("Bills.__Description"),
          width: "20%",
          style: "min-width:200px"
        },
        {
          text: this.$t("Bills.__Quantity"),
          width: "8%",
          style: "min-width:100px"
        },
        {
          text: this.$t("Bills.__Price"),
          width: "8%",
          style: "min-width:120px"
        },
        {
          text: this.$t("Bills.__Tax"),
          width: "15%",
          style: "min-width:200px"
        },
        {
          text: this.$t("Bills.__Amount"),
          width: "",
          style: "min-width:150px",
          class: "text-right"
        },
        {
          text: "",
          width: "20px",
          style: ""
        }
      ],
      currency: {
        symbol: "ABC$",
        code: "ABC",
        name: "Taiwan ABC Dollar",
        id: 206
      },
      bill: {
        vendor: {},
        items: [],
        name: "",
        number: "",
        amount: 0,
        subtotal: 0,
        total: 0,
        taxAmount: 0,
        currencyCode: "TWD",
        startDate: "",
        issuedAt: "",
        endDate: "",
        expiredAt: "",
        poso: "",
        memo: ""
        // currency: {
        //     symbol: "NT$",
        //     code: "TWD",
        //     name: "Taiwan New Dollar",
        //     id: 206
        // },
        // subhead: "",
        // title: "",
        // number: "",
        // memo: "",
        // footer: "",
        // startDate: "",
        // endDate: "",
        // vendor: {},
        // items: []
      }
    }
  },
  computed: {},
  methods: {
    getBill(id) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/getBill", id)
        .then(
          function (response) {
            this.bill = response.data
            this.updateAmount()
            this.updateProduct()

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function (error) { }.bind(this))
    },
    getTransactionRecords(id) {
      this.$store
        .dispatch("transactions/getBillTransactionRecords", id)
        .then(
          function (response) {
            this.transactionRecords = response.data

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function (error) { }.bind(this))
    },
    productItemChanged(i) {
      this.bill.items[i].price = this.bill.items[i].product.price
      this.bill.items[i].accountId = this.bill.items[i].product.expenseAccountId
      this.bill.items[i].taxes = this.bill.items[i].product.taxes
      this.updateAmount()
    },
    addItem() {
      this.bill.items.push({
        product: { taxes: [] },
        price: 0,
        quantity: 1,
        taxes: [],
        description: ""
      })
    },
    removeItem(idx) {
      this.bill.items.splice(idx, 1)
      this.updateAmount()
    },
    saveEdit() {
      this.$refs.billform.validate()

      if (this.bill.items.length == 0) {
        this.$store.dispatch("global/showAlertError", this.$t("Messages.__AtLeastOneProduct"))
        return
      }

      if (this.formValid) {
        //taxids
        this.bill.vendorId = this.bill.vendor.id
        // this.bill.issuedAt = this.bill.startDate
        // this.bill.expiredAt = this.bill.endDate
        for (var item of this.bill.items) {
          if (item.product != undefined) {
            if (item.product.name != undefined) {
              item.name = item.product.name
            } else {
              item.name = "--"
            }
          }
          item.taxIds = []
          for (var tax of item.taxes) {
            item.taxIds.push(tax.id)
          }
          // delete item["product"]
          // delete item["taxes"]
        }

        if (this.editType == 1) {
          this.createBill()
        } else {
          this.updateBill()
        }
      }
    },
    createBill() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/createBill", this.bill)
        .then(
          function (response) {
            this.id = response.data.billId
            this.doneAction(this.$t("Messages.__SuccessfullyCreated"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    updateBill() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/updateBill", this.bill)
        .then(
          function (response) {
            this.doneAction(this.$t("Messages.__SuccessfullyUpdated"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    deleteItem() {
      this.deleteDialog = true
    },
    deleteBill() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("bills/deleteBill", this.id)
        .then(
          function (response) {
            this.doneAction(this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    doneAction(messege) {
      this.savedTag = true
      this.$router.push({
        name: "Bills",
        params: {
          alert: {
            message: messege,
            type: "success"
          }
        }
      })
    },
    updateAmount() {
      var amount = 0
      var taxAmount = 0
      for (var item of this.bill.items) {
        item.amount = item.quantity * item.price || 0
        item.taxAmount = 0
        for (var tax of item.taxes) {
          tax.amount = (item.quantity * item.price * tax.rate) / 100 || 0
          item.taxAmount += tax.amount
        }
        item.total = item.amount + item.taxAmount || 0
        amount += item.amount
        taxAmount += item.taxAmount
      }
      this.bill.subtotal = amount
      this.bill.taxAmount = taxAmount
      this.bill.total = amount + taxAmount
    },
    updateProduct() { },
    currencyUpdated(val) {
      this.currency = this.getCurrency(val)
    },
    deleteTransaction() {
      this.$store
        .dispatch("transactions/deleteTransaction", this.selectTransaction.id)
        .then(
          function (response) {
            this.getTransactionRecords(this.id)
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    }
  },
  watch: {},
  mounted() {
    // Sortable.create(document.querySelector("#dragTable"), {
    //   handle: ".drag-handle",
    //   onEnd({ newIndex, oldIndex }) { }
    // })
  },
  created() {
    this.biz = this.$store.getters["bizes/biz"]()
    this.currencyUpdated(this.biz.currencyCode)
    this.bill.currencyCode = this.biz.currencyCode
    if (this.$route.name == "BillNew") {
      this.editType = 1
      this.$store
        .dispatch("bills/getBills", {
          pageNumber: 1,
          pageSize: 5000
        })
        .then(
          function (response) {
            this.bill.number = `${response.data.length + 1}`
          }.bind(this)
        )
        .catch(
          function (error) {
          }.bind(this)
        )
    } else {
      this.id = this.$route.params.id
      this.editType = 2
      this.getBill(this.id)
      this.getTransactionRecords(this.id)
    }

  }
}
</script>
<style lang="scss" scoped>
.product-name {
  font-size: 16px;
}

.insert-table td,
.insert-table th {
  padding: 8px 8px !important;
  font-size: 16px;

  .tax-area {
    font-size: 13px;
    opacity: 0.8;
  }
}

.tax-amount:first-child {
  margin-top: 8px;
}

.drag-handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}

.subtotal,
.taxtotal,
.total,
.paid,
.unpaid {
  font-size: 16px;
  color: #1e1e21;
  line-height: 1.5;

  td {
    border-top: 0;
    height: auto;
    padding-right: 0;
  }
}
</style>
